<app-sidebar-inner
  #sidebarInnerComponent
  [sidebarComponent]="this"
  [instancesComponent]="instancesComponent()"
/>
<app-sidebar-controls
  [itemsInnerComponent]="sidebarInnerComponent.itemsComponent().itemsInnerComponent()"
/>
